import Component from '@glimmer/component';

import { array } from '@ember/helper';
import { service } from '@ember/service';

import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import ReloadModel from 'rise-ui/components/reload-model.gjs';
import Sticky from 'rise-ui/components/sticky.gjs';
import DefaultDates from 'rise-ui/components/time-series/selection/default-dates.gjs';
import Location from 'rise-ui/components/time-series/selection/line/location.gjs';
import Records from 'rise-ui/components/time-series/selection/records.gjs';
import notIn from 'rise-ui/helpers/not-in.js';
import string from 'rise-ui/helpers/string.js';
import sticky from 'rise-ui/modifiers/sticky.js';
import { or } from 'rise-ui/utils/object/computed';

export default class TimeSeriesSelectionLocationsComponent extends Component {
  @service('time-series/selected-locations') selectedLocations;
  @service ssr;

  @or('selectedLocations.locations.isPending', 'ssr.isSsr') isLoading;

  <template>
    <div class="c-time-series-selection-lined c-lined">
      {{#if this.selectedLocations.locations.isRejected}}
        <div class="c-no-result c-search__results-error qa-query-error">
          Error fetching locations. <ReloadModel>Retry</ReloadModel>
        </div>
      {{else}}
        <DefaultDates />
        {{#each this.selectedLocations.locations.value as | location |}}
          {{#if (notIn this.selectedLocations.hidden.locations location.id)}}
            <Sticky @name="location" @pause={{array "record" "item"}}>
              <div class="c-sticky-subtitle">Location</div>
              <div class="c-time-series-selection-line__label">
                {{location.name}}
              </div>
            </Sticky>
            <ExpandingBlock
              @button={{true}}
              @initExpanded={{true}}
              @iconClass="c-time-series-selection-line__expander c-time-series-selection-line-location__expander"
            >
              <:head>
                <Location
                  @location={{location}}
                  {{sticky activate="location"}}
                />
              </:head>
              <:body>
                <Records
                  @location={{location}}
                  @hasItem={{@hasItem}}
                  @isValidItem={{@isValidItem}}
                  @itemDates={{@itemDates}}
                  @hasModelRun={{@hasModelRun}}
                  @isValidModelRun={{@isValidModelRun}}
                  @modelRunDates={{@modelRunDates}}
                />
              </:body>
            </ExpandingBlock>
          {{/if}}
        {{else}}
          {{#if this.isLoading}}
            <div class="c-no-result c-search__results-init qa-query-loading">
              Loading {{string "time-series-selected-locations"}}...
            </div>
          {{else}}
            <div class="c-no-result c-search__results-empty qa-query-empty">
              Please select locations in order to specify your query.
            </div>
          {{/if}}
        {{/each}}
      {{/if}}
    </div>
  </template>
}
